<template>
  <div class="dados-alimentacao-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Racao')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12" md="6">
          <field-section
            :label="$t('Tipo')"
            :value="pet.tipoRacao | toPT_BRCapitalize"
            :is-restrict="$store.getters['pet/isRestrict']('tipoRacao')"
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="6">
          <field-section
            :label="$t('Marca')"
            :value="pet.marcaRacao | toPT_BRCapitalize"
            :is-restrict="$store.getters['pet/isRestrict']('marcaRacao')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Alimentacao") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Alimentacao"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
  },
};
</script>

<style scoped></style>
